// extracted by mini-css-extract-plugin
export default {"container":"uejR6TEsIQeEDF3h69f7","themeColour":"Xwg_bbV9Xi3ZhV4zidrA","darkThemeColour":"Ce81uMHQ0lYYoRth6AUv","signUpDetailsContainer":"Sk7B2BfO9wsQW4EuXvyd"};